import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Div } from "components/Base";
import { actions, getters } from "../../model";
import Footer from "./Footer";
import Loading from "./Loading";
import SubSessionsStepper from "./Header";
import ConvertToSubsessions from "./ConverToSubsessions";
import { SUBSESSIONS_TAB } from "../../constants";
import { noop } from "lodash";
import SelectSessions from "./SelectSessions";

const decorate = connect(
  (state, props) => ({
    sessionsToConvert: getters.sessionsToConvert(state, props),
    loading: getters.loading(state, props),
    sessionsToConvertCounter: getters.sessionsToConvertCounter(state, props),
    pagination: getters.pagination(state, props),
    linkSessionsToSubsessionsTab: getters.linkSessionsToSubsessionsTab(state)
  }),
  {
    selectItem: actions.selectItem,
    searchSessions: actions.searchSessions
  }
);

const View = ({
  loading = true,
  searchSessions = noop,
  linkSessionsToSubsessionsTab = SUBSESSIONS_TAB.SELECT_SESSIONS,
  handlers = {}
}) => {
  useEffect(() => {
    searchSessions({ filter: "" });
  }, []);

  return (
    <Div
      bg="white"
      p={8}
      style={{
        overflowY: "auto"
      }}
      width={1}
    >
      <SubSessionsStepper />

      {loading ? (
        <Loading />
      ) : (
        <Div>
          {linkSessionsToSubsessionsTab === SUBSESSIONS_TAB.SELECT_SESSIONS ? (
            <SelectSessions />
          ) : (
            <ConvertToSubsessions />
          )}
        </Div>
      )}
      <Footer handlers={handlers} />
    </Div>
  );
};

export default decorate(View);
